(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bags-collection-polish"] && !Shopify.designMode) return;
  try {
    
  document.documentElement.classList.add('bags-collection-template');
  document.documentElement.lang = 'en-CA';

  const bagsEnglishLabels = new Map([
    ['Disponibilidade', 'Availability'],
    ['Preço', 'Price'],
    ['Em stock', 'In stock'],
    ['Esgotado', 'Out of stock'],
    ['Filtrar', 'Filter'],
    ['Filtros', 'Filters'],
    ['Ordenar', 'Sort'],
    ['Limpar', 'Clear'],
    ['Limpar tudo', 'Clear all'],
    ['Aplicar', 'Apply'],
    ['De', 'From'],
    ['Para', 'To']
  ]);

  const localizeBagsControls = (root = document) => {
    const controls = root.querySelector('results-list');
    if (!controls) return;

    const walker = document.createTreeWalker(controls, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();
    while (textNode) {
      const original = textNode.nodeValue.trim();
      if (bagsEnglishLabels.has(original)) {
        textNode.nodeValue = textNode.nodeValue.replace(original, bagsEnglishLabels.get(original));
      } else {
        textNode.nodeValue = textNode.nodeValue.replace(/Ver (\d+) itens/g, 'View $1 items');
      }
      textNode = walker.nextNode();
    }

    controls.querySelectorAll('[aria-label], [title]').forEach((element) => {
      ['aria-label', 'title'].forEach((attribute) => {
        const value = element.getAttribute(attribute);
        if (value && bagsEnglishLabels.has(value.trim())) {
          element.setAttribute(attribute, bagsEnglishLabels.get(value.trim()));
        }
      });
    });
  };

  localizeBagsControls();
  new MutationObserver(() => localizeBagsControls()).observe(document.body, {
    childList: true,
    subtree: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bags-product-polish"] && !Shopify.designMode) return;
  try {
    
  document.documentElement.classList.add('bags-product-template');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
